module.exports = __webpack_public_path__ + "static/media/deliverycloud2.63961f1d.JPG";